<div [ngClass]="{'page-background': useRebrandedLayout }">
  <div class="container ">

    <ngb-alert *ngIf="alert" [type]="alert.type" (closed)="closeAlert()" class="sticky-top" style="top: 10px;">{{ alert.message }}</ngb-alert>

    <div class="row mb-3">
      <div class="col-12">
        <h1 class="text-center mt-4" [ngClass]="{'page-title': useRebrandedLayout }">
          Change password
        </h1>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12 text-center mt-5 mb-3">
        <h5 [ngClass]="{'page-title': useRebrandedLayout }">
          To change your password, please fill in the fields below:
        </h5>
      </div>
    </div>

    <div class="row mb-5">
      <div [ngClass]="useRebrandedLayout ? 'mx-auto mb-3 col-md-6' : 'col-12 col-md-8 col-lg-4 offset-md-2 offset-lg-4 mb-3'">
        <form
          #updatePasswordForm="ngForm"
          (ngSubmit)="save(updatePasswordForm)"
          [appMatchingFields]="['passwordNew', 'passwordNewConfirm']"
          novalidate>
          <div [ngClass]="{'form-card h-100 p-4': useRebrandedLayout}">
            <div class="mb-3">
              <label class="form-label" for="passwordCurrent">
                Current password
              </label>
              <input
                #passwordCurrent="ngModel"
                class="form-control"
                [class.is-invalid]="passwordCurrent.touched && !passwordCurrent.valid"
                id="passwordCurrent"
                minlength="8"
                name="passwordCurrent"
                [(ngModel)]="model.oldPassword"
                placeholder="Current password"
                required
                type="password">
              <div
                *ngIf="passwordCurrent.errors && passwordCurrent.errors.required"
                class="invalid-feedback">
                {{ errorStrings.required }}
              </div>
              <div
                *ngIf="passwordCurrent.errors && passwordCurrent.errors.minlength"
                class="invalid-feedback">
                {{ errorStrings.passwordTooShort }}
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label" for="passwordNew">
                New password
              </label>
              <input
                #passwordNew="ngModel"
                class="form-control"
                [class.is-invalid]="passwordNew.touched && !passwordNew.valid"
                type="password"
                id="passwordNew"
                name="passwordNew"
                [(ngModel)]="model.password"
                placeholder="New password"
                required
                passwordStrength
                >
              <div
                *ngIf="passwordNew.errors && passwordNew.errors.required"
                class="invalid-feedback">
                {{ errorStrings.required }}
              </div>
            </div>
            <app-zxcvbn-password-strength [password]="model.password" [control]="passwordNew" />

            <div>
              <label class="form-label" for="passwordNewConfirm">
                Confirm new password
              </label>
              <input
                #passwordNewConfirm="ngModel"
                class="form-control"
                [class.is-invalid]="passwordNewConfirm.touched && !passwordNewConfirm.valid"
                id="passwordNewConfirm"
                minlength="8"
                name="passwordNewConfirm"
                ngModel=""
                placeholder="Confirm new password"
                required
                type="password">
              <div
                *ngIf="passwordNewConfirm.errors && passwordNewConfirm.errors.required"
                class="invalid-feedback">
                {{ errorStrings.required }}
              </div>
              <div
                *ngIf="passwordNewConfirm.errors && passwordNewConfirm.errors.minlength"
                class="invalid-feedback">
                {{ errorStrings.passwordTooShort }}
              </div>
              <div
                *ngIf="passwordNewConfirm.errors && passwordNewConfirm.errors.matchingFields"
                class="invalid-feedback">
                {{ errorStrings.passwordMismatch }}
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <button
              class="btn btn-success text-white btn-lg w-75 mt-5"
              [ngClass]="useRebrandedLayout ? 'w-75' : 'w-100'"
              [disabled]="!updatePasswordForm.valid || loading"
              type="submit">
              <fa-icon *ngIf="loading" [icon]="['fas', 'spinner']" [animation]="'spin'" class="me-3"></fa-icon>
              {{ loading ? 'Updating' : 'Update' }}
            </button>
          </div>
        </form>

      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12 d-flex justify-content-start mb-3">
        <a [routerLink]="['/account']">
          <fa-icon [icon]="['fas', 'angle-left']"></fa-icon> Back to my account
        </a>
      </div>
    </div>
  </div>
</div>
